import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class UsuarioService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: HttpClient) { }

	getTotalUsuarios() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuarios/total')
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getUsuarios(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuarios' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getUsuariosFiltro(id, filtro={}, pagina=1) {

		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuarios/filtro/' + id + '/' + pagina + params)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}	


	getUsuariosFiltroQtd(id, filtro) {

		let params = '';

		for (let f in filtro) {
			let val = filtro[f];
			if (val) {
				let aux = f.split('___');

				params += (params == '')? '?' : '&';
				params += f + "=" + val;
			}
		}

		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuarios/filtroQtd/' + id + params)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}		

	getUsuariosPag(limit, offset) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuarios/pag/' + limit + '/' + offset)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getUsuario(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuarios/' + id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	
	getPerfis() {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/perfis')
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaUsuario(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/usuarios', {
				usuario_nome: data.usuario_nome,
				usuario_email: data.usuario_email,
				usuario_cpf: data.usuario_cpf,
				usuario_rg: data.usuario_rg,
				usuario_data_nascimento: data.usuario_data_nascimento,
				usuario_login: data.usuario_login,
				usuario_senha: data.usuario_senha,
				usuario_perfil: data.usuario_perfil,
				usuario_situacao: data.usuario_situacao,
				unidades: data.unidades,
				profissional_id: data.profissional_id
			})
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	
	editaUsuario(data) {
		return new Promise((resolve, reject) => {
			let params = {
				usuario_nome: data.usuario_nome,
				usuario_email: data.usuario_email,
				usuario_cpf: data.usuario_cpf,
				usuario_rg: data.usuario_rg,
				usuario_data_nascimento: data.usuario_data_nascimento,
				usuario_login: data.usuario_login,
				usuario_perfil: data.usuario_perfil,
				usuario_situacao: data.usuario_situacao,
				unidades: data.unidades,
				profissional_id: data.profissional_id
			};
			if (data.usuario_senha !== '')
			params['usuario_senha'] = data.usuario_senha;
			
			this.http.put(this.url + '/usuarios/' + data.usuario_id, params)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	
	apagaUsuario(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/usuarios/' + id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	
	userData(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuarios/userData/' + id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
	
	trocaSenha(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/usuarios/trocasenha', {
				usuario_id: data.usuario_id,
				senha_atual: data.senha_atual,
				senha_nova: data.senha_nova,
				senha_confirma: data.senha_confirma
			})
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	esqueciSenha(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/usuarios/esquecisenha', {
				email: data.email
			})
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


	ClienteUnidadeUser(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/usuarios/getClienteUnidade/' + id)
			.map(res => res)
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}


}
